export const generateTimestamp = (): string => {
  return new Date().toISOString();
};
